import { setDeleteTransformationRow as setDeleteTransformationRowDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';


export type SetDeleteTransformationRowProps = ApiMethodBase & {
    mapping: string;
};

export const setDeleteTransformationRow = ({
    mapping,
}: SetDeleteTransformationRowProps) => {
    setDeleteTransformationRowDiagram(mapping);
};
